/* ============================================================
   iEvolution — Reto 7D "3 REGALOS GRATIS" landing (PageFly)
   Widget de compra + secciones nuevas + descripción. Un solo archivo.
   ============================================================ */
if (!window.__r7gLoaded) { window.__r7gLoaded = true;
(function () {
  function bootR7G() {
    (function () {

      /* ---------------- CONFIG (lo único que hay que tocar) ---------------- */
      var CONFIG = {
        // Producto que se compra
        main: { handle: '7d-challenge', variantId: 51198000726289 },

        // Los 3 regalos. Se agregan al carrito junto con el kit.
        gifts: [
          { key: 'liver', handle: 'daily-liver-plus', variantId: 51525905482001 },
          { key: '365',   handle: '365-family-size',  variantId: 53403467809041 },
          { key: 'smr',   handle: 'smr',              variantId: 54680805638417 }
        ],

        // Código de descuento tipo "Compra X, llévate Y" que pone los 3 regalos en $0.
        // Déjalo vacío ('') si usas un descuento AUTOMÁTICO en Shopify (sin código).
        discountCode: '',

        // Reseñas mostradas bajo el título
        rating: '4.8', ratingCountEN: '2,300+ happy customers', ratingCountES: 'más de 2,300 clientes felices',

        // Urgencia / prueba social (pon false para apagar cualquiera)
        showCountdown: true, countdownMinutes: 10,
        showStock: true, showViewers: true, showToasts: true,

        // Precio "antes" del kit si Shopify no trae compare_at_price
        compareAtFallback: 199.99
      };
      /* --------------------------------------------------------------------- */

      var widget = document.querySelector('.ievo7d-widget');
      if (!widget) return;

      var $ = function (id) { return document.getElementById(id); };
      var loadingEl = $('ievo7d-loading');
      var errorEl = $('ievo7d-error');
      var mainContent = $('ievo7d-main-content');
      var infoCard = $('ievo7d-info-card');
      var mainButton = widget.querySelector('.ievo7d-checkout-btn');
      var stickyButton = widget.querySelector('.ievo7d-sticky-btn');

      var isSpanish = /\/(es|es-mx)(\/|$)/.test(window.location.pathname);
      var T = isSpanish ? 'es' : 'en';

      /* ---------------- Textos EN / ES ---------------- */
      var TXT = {
        en: {
          eyebrow: 'Buy 1 kit · Get 3 full-size gifts FREE',
          titleSuffix: '+ 3 FREE Gifts',
          urgencyLabel: '⚡ Your 3 free gifts expire in:',
          urgencyNote: 'When the timer hits zero, the gifts are gone and the kit goes back to full price.',
          kitName: '7D Challenge Kit',
          kitDesc: 'Colon-D + ProEnzi+ + Liver-D · full 7-day protocol',
          plusGifts: 'Your 3 free gifts',
          plusGiftsMulti: function (n) { return 'Your ' + n + ' free gifts (3 per kit)'; },
          qtyLabel: 'How many kits?',
          qtyHint: 'Each kit comes with its own 3 free gifts',
          free: 'FREE',
          value: 'value',
          totalValue: 'Total value',
          youPay: 'You pay today',
          youSave: 'You save',
          gifts: {
            liver: { name: 'Daily Liver Plus', desc: '60 capsules · 30 days of liver support after your detox' },
            '365': { name: '365 Daily Multi-Vitamin', desc: '100+ nutrients in one scoop · 30 servings' },
            smr:   { name: 'SMR Smart Meal Replacement', desc: '22 g protein · vanilla · 21 servings' }
          },
          stock: function (n) { return 'Only ' + n + ' gift bundles left – order soon!'; },
          claimed: function (p) { return p + "% of today's gift bundles already claimed"; },
          viewers: function (n) { return n + ' people viewing this now'; },
          buyNow: 'Get My Kit + 3 Free Gifts',
          buyNowMulti: function (n) { return 'Get My ' + n + ' Kits + ' + (n * 3) + ' Free Gifts'; },
          addToCart: 'Add to Cart',
          added: 'Kit + 3 gifts added to cart',
          viewCart: 'View cart →',
          sticky: 'Claim My 3 Free Gifts',
          toastAction: 'just claimed the 7D Kit + 3 gifts',
          toastTime: function (m) { return m + ' min ago'; },
          error: 'Something went wrong. Please try again.'
        },
        es: {
          eyebrow: 'Compra 1 kit · Llévate 3 regalos GRATIS',
          titleSuffix: '+ 3 Regalos GRATIS',
          urgencyLabel: '⚡ Tus 3 regalos expiran en:',
          urgencyNote: 'Cuando el reloj llegue a cero, los regalos desaparecen y el kit vuelve a precio normal.',
          kitName: 'Kit Reto 7D',
          kitDesc: 'Colon-D + ProEnzi+ + Liver-D · protocolo completo de 7 días',
          plusGifts: 'Tus 3 regalos gratis',
          plusGiftsMulti: function (n) { return 'Tus ' + n + ' regalos gratis (3 por kit)'; },
          qtyLabel: '¿Cuántos kits?',
          qtyHint: 'Cada kit trae sus propios 3 regalos',
          free: 'GRATIS',
          value: 'de valor',
          totalValue: 'Valor total',
          youPay: 'Pagas hoy',
          youSave: 'Ahorras',
          gifts: {
            liver: { name: 'Daily Liver Plus', desc: '60 cápsulas · 30 días de soporte hepático después del detox' },
            '365': { name: '365 Multivitamínico Diario', desc: 'Más de 100 nutrientes en un scoop · 30 porciones' },
            smr:   { name: 'SMR Sustituto de Comida', desc: '22 g de proteína · vainilla · 21 porciones' }
          },
          stock: function (n) { return '¡Solo quedan ' + n + ' paquetes con regalo – ordena pronto!'; },
          claimed: function (p) { return p + '% de los paquetes con regalo de hoy ya reservados'; },
          viewers: function (n) { return n + ' personas viendo esto ahora'; },
          buyNow: 'Quiero Mi Kit + 3 Regalos',
          buyNowMulti: function (n) { return 'Quiero Mis ' + n + ' Kits + ' + (n * 3) + ' Regalos'; },
          addToCart: 'Agregar al Carrito',
          added: 'Kit + 3 regalos agregados al carrito',
          viewCart: 'Ver carrito →',
          sticky: 'Reclamar Mis 3 Regalos',
          toastAction: 'acaba de reclamar el Kit 7D + 3 regalos',
          toastTime: function (m) { return 'hace ' + m + ' min'; },
          error: 'Algo salió mal. Intenta de nuevo.'
        }
      }[T];

      /* ---------------- Moneda ---------------- */
      function getCurrencyInfo() {
        var info = { code: 'USD', symbol: '$', locale: 'en-US' };
        if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) info.code = Shopify.currency.active;
        if (info.code === 'USD' && window.location.pathname.indexOf('/es-mx') !== -1) info.code = 'MXN';
        var map = { USD: { symbol: '$', locale: 'en-US' }, MXN: { symbol: '$', locale: 'es-MX' }, EUR: { symbol: '€', locale: 'es-ES' }, CAD: { symbol: 'CA$', locale: 'en-CA' }, GBP: { symbol: '£', locale: 'en-GB' } };
        if (map[info.code]) { info.symbol = map[info.code].symbol; info.locale = map[info.code].locale; }
        return info;
      }
      var cur = getCurrencyInfo();

      function fmt(amount) {
        try { return amount.toLocaleString(cur.locale, { style: 'currency', currency: cur.code, minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
        catch (e) { return cur.symbol + amount.toFixed(2); }
      }

      function root() {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
        var m = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//i);
        if (m) return '/' + m[1] + '/';
        if (window.location.pathname.indexOf('/es/') === 0) return '/es/';
        return '/';
      }

      /* ---------------- Datos de producto ----------------
         /products/<handle>.js devuelve precios en centavos, localizados al mercado
         de la URL (/es-mx/ → MXN). Se piden los 4 en paralelo. */
      function fetchProduct(handle) {
        return fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + handle); return r.json(); });
      }

      function pickVariant(product, variantId) {
        var v = null, i;
        for (i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(variantId)) { v = product.variants[i]; break; }
        return v || product.variants[0];
      }

      function loadAll() {
        var handles = [CONFIG.main.handle].concat(CONFIG.gifts.map(function (g) { return g.handle; }));
        return Promise.all(handles.map(fetchProduct)).then(function (list) {
          var mainP = list[0], mv = pickVariant(mainP, CONFIG.main.variantId);
          var data = {
            main: {
              title: mainP.title,
              price: mv.price / 100,
              compareAt: mv.compare_at_price ? mv.compare_at_price / 100 : CONFIG.compareAtFallback,
              variantId: mv.id,
              image: mainP.featured_image || (mainP.images && mainP.images[0]) || ''
            },
            gifts: []
          };
          for (var i = 0; i < CONFIG.gifts.length; i++) {
            var p = list[i + 1], gv = pickVariant(p, CONFIG.gifts[i].variantId);
            data.gifts.push({
              key: CONFIG.gifts[i].key,
              variantId: gv.id,
              price: gv.price / 100,
              image: p.featured_image || (p.images && p.images[0]) || ''
            });
          }
          return data;
        });
      }

      /* ---------------- Render ---------------- */
      var state = { data: null, qty: 1 };
      var MAX_QTY = 10;

      function imgUrl(src, size) {
        if (!src) return '';
        src = src.replace(/^\/\//, 'https://');
        var m = src.match(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i);
        return m ? src.replace(m[0], '_' + size + m[0]) : src;
      }

      function render(data) {
        state.data = data;
        var giftsValue = 0;
        data.gifts.forEach(function (g) { giftsValue += g.price; });
        var kitAnchor = data.main.compareAt > data.main.price ? data.main.compareAt : data.main.price;
        var totalValue = kitAnchor + giftsValue;
        var pay = data.main.price;
        var save = totalValue - pay;
        var savePct = Math.round((save / totalValue) * 100);

        $('ievo7d-eyebrow-text').textContent = TXT.eyebrow;
        $('ievo7d-product-title').textContent = (isSpanish ? 'Reto 7D: Limpieza de Colon, Hígado y Vesícula' : '7-Day Detox Challenge') + ' ' + TXT.titleSuffix;
        var rc = $('ievo7d-rating-count'); if (rc) rc.textContent = isSpanish ? CONFIG.ratingCountES : CONFIG.ratingCountEN;
        var rv = $('ievo7d-rating-value'); if (rv) rv.textContent = CONFIG.rating;

        $('ievo7d-urgency-label').textContent = TXT.urgencyLabel;
        $('ievo7d-urgency-note').textContent = TXT.urgencyNote;

        // Kit
        $('ievo7d-kit-img').src = imgUrl(data.main.image, '160x160');
        $('ievo7d-kit-name').textContent = TXT.kitName;
        $('ievo7d-kit-desc').textContent = TXT.kitDesc;
        var kc = $('ievo7d-kit-compare');
        if (data.main.compareAt > data.main.price) { kc.textContent = fmt(data.main.compareAt); kc.style.display = ''; } else { kc.style.display = 'none'; }
        $('ievo7d-kit-price').textContent = fmt(data.main.price);

        // Regalos
        $('ievo7d-plus-gifts').textContent = state.qty > 1 ? TXT.plusGiftsMulti(state.qty * data.gifts.length) : TXT.plusGifts;
        var list = $('ievo7d-gift-list'); list.innerHTML = '';
        data.gifts.forEach(function (g, i) {
          var t = TXT.gifts[g.key] || { name: g.key, desc: '' };
          var li = document.createElement('li');
          li.className = 'ievo7d-gift';
          li.innerHTML =
            '<span class="ievo7d-gift-num">' + (i + 1) + '</span>' +
            '<img class="ievo7d-gift-img" alt="" loading="lazy" decoding="async">' +
            '<span class="ievo7d-gift-body"><strong></strong><span></span></span>' +
            '<span class="ievo7d-gift-price"><s></s><b class="ievo7d-free-badge"></b></span>';
          li.querySelector('img').src = imgUrl(g.image, '120x120');
          li.querySelector('strong').textContent = t.name + (state.qty > 1 ? ' ×' + state.qty : '');
          li.querySelector('.ievo7d-gift-body > span').textContent = t.desc;
          li.querySelector('s').textContent = fmt(g.price * state.qty);
          li.querySelector('b').textContent = TXT.free;
          list.appendChild(li);
        });

        // Cantidad
        $('ievo7d-qty-label').textContent = TXT.qtyLabel;
        $('ievo7d-qty-hint').textContent = TXT.qtyHint;
        $('ievo7d-qty-value').textContent = state.qty;
        $('ievo7d-qty-minus').disabled = state.qty <= 1;
        $('ievo7d-qty-plus').disabled = state.qty >= MAX_QTY;

        // Totales (× cantidad de kits)
        var q = state.qty;
        $('ievo7d-total-label').textContent = TXT.totalValue + (q > 1 ? ' (' + q + ' kits)' : '');
        $('ievo7d-total-value').textContent = fmt(totalValue * q);
        $('ievo7d-pay-label').textContent = TXT.youPay;
        $('ievo7d-pay-value').textContent = fmt(pay * q);
        $('ievo7d-save-line').textContent = TXT.youSave + ' ' + fmt(save * q) + ' (' + savePct + '%)';

        // Botones
        $('ievo7d-btn-label').textContent = state.qty > 1 ? TXT.buyNowMulti(state.qty) : TXT.buyNow;
        $('ievo7d-atc-label').textContent = TXT.addToCart;
        $('ievo7d-cart-link').textContent = TXT.viewCart;
        $('ievo7d-cart-link').setAttribute('href', root() + 'cart');
        stickyButton.textContent = TXT.sticky;

        // Shop Pay (4 pagos sobre lo que paga)
        var inst = fmt(pay * q / 4);
        var ie = $('ievo7d-installment'); if (ie) ie.textContent = inst;
        var mie = $('ievo7d-modal-installment'); if (mie) mie.textContent = inst;

        // Exponer para las secciones de abajo (Do the math)
        var giftPrices = {}; data.gifts.forEach(function (g) { giftPrices[g.key] = g.price; });
        var first = !window.__r7g;
        window.__r7g = { totalValue: totalValue, pay: pay, save: save, savePct: savePct, giftsValue: giftsValue, kitAnchor: kitAnchor, giftPrices: giftPrices, fmt: fmt };
        if (first) document.dispatchEvent(new CustomEvent('r7g:ready', { detail: window.__r7g }));
      }

      /* ---------------- URLs de compra ----------------
         Buy Now: permalink de carrito con los 4 artículos + código de descuento.
         Va directo al checkout con los regalos ya en $0. */
      function permalinkItems() {
        var d = state.data;
        var parts = [d.main.variantId + ':' + state.qty];
        d.gifts.forEach(function (g) { parts.push(g.variantId + ':' + state.qty); });
        return parts.join(',');
      }
      function buyNowUrl() {
        var url = root() + 'cart/' + permalinkItems();
        if (CONFIG.discountCode) url += '?discount=' + encodeURIComponent(CONFIG.discountCode);
        return root() + 'cart/clear?return_to=' + encodeURIComponent(url);
      }

      /* ---------------- Add to Cart (AJAX) ---------------- */
      function readJson(res) {
        return res.text().then(function (t) {
          var data = null; try { data = JSON.parse(t); } catch (e) {}
          if (!res.ok || !data || data.status) {
            var msg = TXT.error;
            if (data && (data.description || data.message)) msg = data.description || data.message;
            var err = new Error(msg); err.data = data; throw err;
          }
          return data;
        });
      }
      function cartCount() {
        return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(function (c) { return c && typeof c.item_count === 'number' ? c.item_count : null; })
          .catch(function () { return null; });
      }
      function cartHost() {
        var el = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        return (el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function') ? el : null;
      }
      function sectionIds(host) {
        if (!host) return null;
        try { return host.getSectionsToRender().map(function (s) { return s.id; }).slice(0, 5).join(','); } catch (e) { return null; }
      }
      // update.js = cantidad absoluta (qty de cada) → idempotente y no borra otros artículos del cliente.
      function setBundleInCart() {
        var d = state.data, host = cartHost(), ids = sectionIds(host);
        var body = { updates: {} };
        body.updates[String(d.main.variantId)] = state.qty;
        d.gifts.forEach(function (g) { body.updates[String(g.variantId)] = state.qty; });
        if (ids) { body.sections = ids; body.sections_url = window.location.pathname; }
        return fetch(root() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(readJson);
      }
      // /discount/CODE deja el código en la cookie del checkout (no navega).
      function applyDiscountCookie() {
        if (!CONFIG.discountCode) return Promise.resolve();
        return fetch(root() + 'discount/' + encodeURIComponent(CONFIG.discountCode) + '?redirect=' + encodeURIComponent(root() + 'cart'), { credentials: 'same-origin' })
          .then(function () {}).catch(function () {});
      }

      var OPEN_SEL = 'cart-drawer.active,#CartDrawer.active,cart-notification.active,#cart-notification.active,.mini-cart[aria-hidden="false"],.drawer--cart.is-open,.cart-drawer.is-open,cart-drawer-component[open],theme-drawer[open]';
      var TOGGLE_SEL = '[data-action="toggle-mini-cart"],[data-action="open-drawer"][data-drawer-id="sidebar-cart"],.js-drawer-open-cart,[aria-controls="CartDrawer"],[data-cart-toggle],#cart-icon-bubble';
      function drawerIsOpen() {
        var el; try { el = document.querySelector(OPEN_SEL); } catch (e) { return false; }
        if (!el) return false; var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
      }
      function pollOpen(ms) {
        var deadline = Date.now() + ms;
        return new Promise(function (resolve) { (function tick() { if (drawerIsOpen()) return resolve(true); if (Date.now() > deadline) return resolve(false); setTimeout(tick, 60); })(); });
      }
      function safeToggle() {
        var list = document.querySelectorAll(TOGGLE_SEL), i, el;
        for (i = 0; i < list.length; i++) { el = list[i]; if (el.tagName === 'A' && !document.querySelector('cart-drawer, cart-drawer-component')) continue; return el; }
        return null;
      }
      function openDrawer(res, opts) {
        var btn = opts.button || null;
        // Dawn
        try {
          var host = cartHost();
          if (host && res && res.sections) {
            var line = null; (res.items || []).forEach(function (it) { if (String(it.id) === String(opts.variantId)) line = it; });
            if (btn && typeof host.setActiveElement === 'function') { try { host.setActiveElement(btn); } catch (e) {} }
            host.renderContents({ key: line ? line.key : null, id: line ? line.id : null, sections: res.sections, items: res.items });
            if (typeof window.publish === 'function') { try { window.publish('cart-update', { source: 'r7g-widget', productVariantId: String(opts.variantId), cartData: res }); } catch (e) {} }
            return Promise.resolve(true);
          }
        } catch (e) {}
        // Warehouse (esta tienda) con Cart type = Drawer
        try {
          if (window.theme && window.theme.cartType === 'drawer' && document.querySelector('.mini-cart')) {
            var delta = 4 * state.qty;
            if (res && typeof res.item_count === 'number' && typeof opts.priorItemCount === 'number') delta = res.item_count - opts.priorItemCount;
            if (delta < 1) delta = 4 * state.qty;
            document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: null, button: btn, quantity: delta } }));
            return pollOpen(800).then(function (ok) { return ok ? true : tier3(btn); });
          }
        } catch (e) {}
        return tier3(btn);
      }
      function tier3(btn) {
        try {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: btn } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        } catch (e) {}
        return pollOpen(500).then(function (ok) { if (ok) return true; var t = safeToggle(); if (t) { try { t.click(); } catch (e) {} return pollOpen(600); } return false; });
      }

      function setBtnLoading(btn, on) {
        if (!btn) return;
        if (on) { btn.classList.add('ievo7d-loading'); btn.setAttribute('disabled', 'disabled'); }
        else { btn.classList.remove('ievo7d-loading'); btn.removeAttribute('disabled'); }
      }
      function hideFeedback() { var el = $('ievo7d-cart-feedback'); if (el) el.classList.remove('ievo7d-show'); }
      function showFeedback(isErr, msg) {
        var el = $('ievo7d-cart-feedback'); if (!el) return;
        $('ievo7d-cart-feedback-text').textContent = msg;
        var link = $('ievo7d-cart-link'); if (link) link.style.display = isErr ? 'none' : '';
        el.classList.toggle('ievo7d-err', !!isErr);
        el.classList.add('ievo7d-show');
      }
      function addToCart() {
        if (!state.data) return;
        var btn = $('ievo7d-atc-btn');
        hideFeedback(); setBtnLoading(btn, true);
        cartCount().then(function (prior) {
          return setBundleInCart().then(function (res) {
            return applyDiscountCookie().then(function () {
              return openDrawer(res, { variantId: state.data.main.variantId, priorItemCount: prior, button: btn });
            }).then(function (opened) { if (!opened) showFeedback(false, TXT.added); });
          });
        }).catch(function (err) { showFeedback(true, (err && err.message) || TXT.error); })
          .then(function () { setBtnLoading(btn, false); });
      }

      /* ---------------- Urgencia / prueba social ---------------- */
      function startCountdown() {
        var el = $('ievo7d-countdown'); if (!el) return;
        if (!CONFIG.showCountdown) { var b = $('ievo7d-urgency-banner'); if (b) b.style.display = 'none'; $('ievo7d-urgency-note').style.display = 'none'; return; }
        var end = Date.now() + CONFIG.countdownMinutes * 60000;
        function tick() {
          var diff = end - Date.now();
          if (diff <= 0) { end = Date.now() + CONFIG.countdownMinutes * 60000; diff = end - Date.now(); }
          var m = Math.floor(diff / 60000), s = Math.floor((diff % 60000) / 1000), cs = Math.floor((diff % 1000) / 10);
          el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0') + ':' + String(cs).padStart(2, '0');
        }
        tick(); setInterval(tick, 100);
      }
      function startViewers() {
        var el = $('ievo7d-viewers'); if (!el) return;
        if (!CONFIG.showViewers) { el.parentNode.style.display = 'none'; return; }
        var n = Math.floor(Math.random() * 30) + 35;
        el.textContent = TXT.viewers(n);
        setInterval(function () { n = Math.max(20, Math.min(80, n + Math.floor(Math.random() * 7) - 3)); el.textContent = TXT.viewers(n); }, 8000);
      }
      function updateStock() {
        var wrap = widget.querySelector('.ievo7d-stock-wrap'); if (!wrap) return;
        if (!CONFIG.showStock) { wrap.style.display = 'none'; return; }
        var stock = Math.floor(Math.random() * 15) + 15;
        $('ievo7d-stock-text').textContent = TXT.stock(stock);
        var claimed = Math.min(94, Math.max(70, 105 - stock));
        $('ievo7d-stock-fill').style.width = claimed + '%';
        $('ievo7d-stock-claimed').textContent = TXT.claimed(claimed);
      }
      function startToasts() {
        var toast = $('ievo7d-toast'); if (!toast || !CONFIG.showToasts) return;
        var peopleEN = [{ n: 'Sophia', c: 'Houston, TX' }, { n: 'James', c: 'Miami, FL' }, { n: 'Emily', c: 'Phoenix, AZ' }, { n: 'Michael', c: 'Chicago, IL' }, { n: 'Olivia', c: 'Denver, CO' }, { n: 'David', c: 'Austin, TX' }, { n: 'Ava', c: 'Seattle, WA' }, { n: 'Daniel', c: 'Atlanta, GA' }];
        var peopleES = [{ n: 'Sofía', c: 'CDMX' }, { n: 'Mateo', c: 'Guadalajara' }, { n: 'Valentina', c: 'Monterrey' }, { n: 'Santiago', c: 'Puebla' }, { n: 'Camila', c: 'Querétaro' }, { n: 'Diego', c: 'Tijuana' }, { n: 'Lucía', c: 'Mérida' }, { n: 'Andrés', c: 'León' }];
        var people = isSpanish ? peopleES : peopleEN, i = Math.floor(Math.random() * people.length);
        function show() {
          var p = people[i % people.length]; i++;
          $('ievo7d-toast-avatar').textContent = p.n.charAt(0);
          $('ievo7d-toast-name').textContent = p.n + ' · ' + p.c;
          $('ievo7d-toast-action').textContent = TXT.toastAction;
          $('ievo7d-toast-time').textContent = TXT.toastTime(Math.floor(Math.random() * 12) + 1);
          toast.classList.add('ievo7d-toast-show');
          setTimeout(function () { toast.classList.remove('ievo7d-toast-show'); }, 4500);
        }
        setTimeout(function loop() { show(); setTimeout(loop, 11000); }, 4000);
      }
      function deliveryDates() {
        var el = $('ievo7d-delivery-dates'); if (!el) return;
        var s = new Date(), e = new Date(); s.setDate(s.getDate() + 2); e.setDate(e.getDate() + 4);
        var o = { weekday: 'long', month: 'long', day: 'numeric' }, loc = isSpanish ? 'es-ES' : 'en-US';
        el.textContent = isSpanish ? 'Entrega entre ' + s.toLocaleDateString(loc, o) + ' y ' + e.toLocaleDateString(loc, o)
                                   : 'Delivered between ' + s.toLocaleDateString(loc, o) + ' and ' + e.toLocaleDateString(loc, o);
      }

      /* ---------------- Interacciones ---------------- */
      function initInteractions() {
        var learn = $('ievo7d-learn-more'), overlay = $('ievo7d-modal-overlay'), close = $('ievo7d-modal-close');
        if (learn && overlay) {
          learn.addEventListener('click', function (e) { e.preventDefault(); overlay.classList.add('ievo7d-modal-open'); document.body.style.overflow = 'hidden'; });
          if (close) close.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); overlay.classList.remove('ievo7d-modal-open'); document.body.style.overflow = ''; });
          overlay.addEventListener('click', function (e) { if (e.target === overlay) { overlay.classList.remove('ievo7d-modal-open'); document.body.style.overflow = ''; } });
        }
        mainButton.addEventListener('click', function () { if (state.data) window.location.href = buyNowUrl(); });
        function setQty(n) { state.qty = Math.max(1, Math.min(MAX_QTY, n)); hideFeedback(); render(state.data); }
        $('ievo7d-qty-minus').addEventListener('click', function () { setQty(state.qty - 1); });
        $('ievo7d-qty-plus').addEventListener('click', function () { setQty(state.qty + 1); });
        var atc = $('ievo7d-atc-btn'); if (atc) atc.addEventListener('click', addToCart);
        stickyButton.addEventListener('click', function () { widget.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        // Cualquier CTA de las secciones de abajo con data-r7g-cta="buy" compra directo, "scroll" sube al widget
        document.querySelectorAll('[data-r7g-cta]').forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            if (b.getAttribute('data-r7g-cta') === 'buy' && state.data) window.location.href = buyNowUrl();
            else widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
        function checkScroll() { var r = mainButton.getBoundingClientRect(); stickyButton.classList.toggle('ievo7d-visible', r.bottom < 0); }
        var ticking = false;
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { checkScroll(); ticking = false; }); } }, { passive: true });
        checkScroll();
      }

      function showContent() {
        loadingEl.style.display = 'none'; errorEl.style.display = 'none';
        mainContent.style.display = 'block'; if (infoCard) infoCard.style.display = 'block';
        var shopPay = widget.querySelector('.ievo7d-shop-pay'); if (shopPay && cur.code !== 'USD') shopPay.style.display = 'none';
        var notice = $('ievo7d-currency-notice');
        if (notice && cur.code !== 'USD') {
          notice.style.display = 'flex';
          var names = isSpanish ? { MXN: 'Peso Mexicano', EUR: 'Euro', CAD: 'Dólar Canadiense', GBP: 'Libra Esterlina' } : { MXN: 'Mexican Peso', EUR: 'Euro', CAD: 'Canadian Dollar', GBP: 'British Pound' };
          $('ievo7d-currency-text').textContent = (isSpanish ? 'Precios mostrados en ' : 'Prices shown in ') + cur.code + ' (' + (names[cur.code] || cur.code) + ')';
        }
        if (isSpanish) {
          var map = { 'ievo7d-trust-1': 'Garantía 30 Días', 'ievo7d-trust-2': 'Pago Seguro', 'ievo7d-trust-3': 'Envío Rápido' };
          Object.keys(map).forEach(function (k) { var el = $(k); if (el) el.textContent = map[k]; });
          var it = widget.querySelectorAll('.ievo7d-info-title'); if (it[0]) it[0].textContent = 'Envío Gratis y Rápido'; if (it[1]) it[1].textContent = 'Pruébalo Sin Riesgo';
          var idesc = widget.querySelectorAll('.ievo7d-info-desc'); if (idesc[1]) idesc[1].textContent = 'Te encanta o te devolvemos tu dinero — reembolso completo en 30 días, sin preguntas. Los regalos te los quedas.';
          var pt = widget.querySelector('.ievo7d-payment-text'); if (pt) pt.textContent = 'Paga de forma segura con tu tarjeta de débito, crédito o PayPal.';
          var spt = widget.querySelector('.ievo7d-shop-pay-text'); if (spt) spt.innerHTML = 'o 4 pagos sin intereses de <strong id="ievo7d-installment">' + ($('ievo7d-installment') ? $('ievo7d-installment').textContent : '') + '</strong> con';
          var lm = $('ievo7d-learn-more'); if (lm) lm.textContent = 'Más información';
        }
      }
      function showError() { loadingEl.style.display = 'none'; errorEl.style.display = 'flex'; }

      loadAll()
        .then(function (data) { render(data); showContent(); initInteractions(); deliveryDates(); startCountdown(); startViewers(); updateStock(); startToasts(); })
        .catch(function (err) { if (window.console) console.error('[r7g] failed to load products:', err); showError(); });
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootR7G); else bootR7G();
})();

/* ============================================================
   Secciones de abajo: "Do the math" + FAQ acordeón + reveal
   ============================================================ */
(function () {
  function init() {
    var isSpanish = /\/(es|es-mx)(\/|$)/.test(window.location.pathname);
    if (isSpanish) document.querySelectorAll('[data-es]').forEach(function (el) { el.innerHTML = el.getAttribute('data-es'); });

    // Números vivos en la sección "Do the math" (vienen del widget)
    function fillMath(d) {
      var set = function (sel, v) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = v; }); };
      set('[data-r7g="total"]', d.fmt(d.totalValue));
      set('[data-r7g="gifts"]', d.fmt(d.giftsValue));
      set('[data-r7g="kit"]', d.fmt(d.kitAnchor));
      set('[data-r7g="pay"]', d.fmt(d.pay));
      set('[data-r7g="save"]', d.fmt(d.save));
      set('[data-r7g="pct"]', d.savePct + '%');
      if (d.giftPrices) Object.keys(d.giftPrices).forEach(function (k) { set('[data-r7g="gift-' + k + '"]', d.fmt(d.giftPrices[k])); });
    }
    if (window.__r7g) fillMath(window.__r7g);
    document.addEventListener('r7g:ready', function (e) { fillMath(e.detail); });

    // FAQ acordeón
    document.querySelectorAll('.r7g-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentNode, open = item.classList.contains('r7g-open');
        item.parentNode.querySelectorAll('.r7g-faq-item').forEach(function (i) { i.classList.remove('r7g-open'); });
        if (!open) item.classList.add('r7g-open');
      });
    });

    // Reveal al hacer scroll
    var els = document.querySelectorAll('.r7g-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var obs = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('r7g-visible'); obs.unobserve(en.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { obs.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('r7g-visible'); }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ===== DESCRIPCIÓN ===== */


/* ============================================================
   Descripción (secciones ie-21d-*): modales + traducciones EN/ES
   ============================================================ */
/* ---- block 1 of 3 (was a separate  tag) ---- */
try {
// Review Modal - ie-21d-reviews
    (function() {
      var section = document.getElementById('ie-21d-reviews');
      if (!section) return;
      var overlay = document.getElementById('ie-21d-reviews-modal');
      if (!overlay) return;
      var mImg = document.getElementById('ie-21d-reviews-modal-img');
      var mQuote = document.getElementById('ie-21d-reviews-modal-quote');
      var mAuthor = document.getElementById('ie-21d-reviews-modal-author');
      var mLocation = document.getElementById('ie-21d-reviews-modal-location');

      section.addEventListener('click', function(e) {
        var node = e.target;
        var card = null;
        while (node && node !== section) {
          if (node.className && typeof node.className === 'string' && node.className.indexOf('review-card') !== -1) { card = node; break; }
          node = node.parentNode;
        }
        if (!card) return;
        var img = card.querySelector('.review-avatar img');
        var quote = card.querySelector('.review-quote');
        var author = card.querySelector('.review-author');
        var location = card.querySelector('.review-location');
        if (img && mImg) mImg.src = img.src;
        if (img && mImg) mImg.alt = img.alt || '';
        if (quote && mQuote) mQuote.textContent = quote.textContent;
        if (author && mAuthor) mAuthor.textContent = author.textContent;
        if (location && mLocation) mLocation.textContent = location.textContent;
        overlay.className = overlay.className + ' active';
        document.body.style.overflow = 'hidden';
      });

      overlay.addEventListener('click', function(e) {
        var node = e.target;
        var isModal = false;
        while (node && node !== overlay) {
          if (node.className && typeof node.className === 'string' && node.className.indexOf('review-modal') !== -1 && node.className.indexOf('review-modal-overlay') === -1) { isModal = true; break; }
          node = node.parentNode;
        }
        if (!isModal) {
          overlay.className = overlay.className.replace(' active', '');
          document.body.style.overflow = '';
        }
      });

      var closeBtn = overlay.querySelector('.review-modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          overlay.className = overlay.className.replace(' active', '');
          document.body.style.overflow = '';
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.className.indexOf('active') !== -1) {
          overlay.className = overlay.className.replace(' active', '');
          document.body.style.overflow = '';
        }
      });
    })();
} catch (e) { if (window.console) console.error('[reto7d] block 1 failed:', e); }

/* ---- block 2 of 3 (was a separate  tag) ---- */
try {
(function() {
    'use strict'; var initialized = false, scrollY = 0;
    function initExperts() {
      var w = document.querySelector('.iev-experts-wrapper'); if (!w || initialized) return;
      var cards = w.querySelectorAll('.iev-expert-card'), modal = w.querySelector('#ievExpertModal'), closeBtn = w.querySelector('.iev-modal-close'), readBtns = w.querySelectorAll('.iev-read-more');
      if (!cards.length || !modal) return; initialized = true;
      var mI=w.querySelector('#ievModalImg'),mN=w.querySelector('#ievModalName'),mT=w.querySelector('#ievModalTitle'),mS=w.querySelector('#ievModalSpecialty'),mB=w.querySelector('#ievModalBio'),mSt=w.querySelector('#ievModalStats'),mBd=w.querySelector('#ievModalBadges');
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var obs = new IntersectionObserver(function(e) { e.forEach(function(en) { if (en.isIntersecting) { en.target.classList.add('iev-visible'); obs.unobserve(en.target); } }); }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
        w.querySelectorAll('.iev-reveal').forEach(function(el) { obs.observe(el); });
      } else { w.querySelectorAll('.iev-reveal').forEach(function(el) { el.classList.add('iev-visible'); }); }
      function openModal(c) { var d=c.dataset; mI.src=d.img||''; mI.alt=d.name||''; mN.textContent=d.name||''; mT.innerHTML='<span></span>'+(d.title||''); mS.textContent=d.specialty||''; mB.textContent=d.bio||''; mSt.innerHTML='<div class="iev-modal-stat-item"><div class="iev-modal-stat-value">'+(d.stat1Value||'')+'</div><div class="iev-modal-stat-label">'+(d.stat1Label||'')+'</div></div><div class="iev-modal-stat-item"><div class="iev-modal-stat-value">'+(d.stat2Value||'')+'</div><div class="iev-modal-stat-label">'+(d.stat2Label||'')+'</div></div>'; mBd.innerHTML=(d.badges||'').split(',').map(function(b){return'<span class="iev-modal-badge">'+b.trim()+'</span>';}).join(''); scrollY=window.scrollY; document.body.classList.add('iev-modal-open'); document.body.style.top='-'+scrollY+'px'; modal.classList.add('iev-active'); }
      function closeModal() { modal.classList.add('iev-closing'); setTimeout(function() { modal.classList.remove('iev-active','iev-closing'); document.body.classList.remove('iev-modal-open'); document.body.style.top=''; window.scrollTo(0,scrollY); },300); }
      readBtns.forEach(function(b) { b.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var c=b.closest('.iev-expert-card'); if(c) openModal(c); }); });
      if (closeBtn) closeBtn.addEventListener('click', function(e) { e.preventDefault(); closeModal(); });
      modal.addEventListener('click', function(e) { if(e.target===modal) closeModal(); });
      document.addEventListener('keydown', function(e) { if(e.key==='Escape'&&modal.classList.contains('iev-active')) closeModal(); });
      var touchY=0, mInner=modal.querySelector('.iev-modal');
      if (mInner) { mInner.addEventListener('touchstart',function(e){touchY=e.touches[0].clientY;},{passive:true}); mInner.addEventListener('touchend',function(e){if(e.changedTouches[0].clientY-touchY>80)closeModal();},{passive:true}); }
    }
    if (document.readyState==='loading') { document.addEventListener('DOMContentLoaded',initExperts); } else { initExperts(); }
    window.addEventListener('load',function(){setTimeout(function(){initialized=false;initExperts();},200);});
  })();
} catch (e) { if (window.console) console.error('[reto7d] block 2 failed:', e); }

/* ---- block 3 of 3 (was a separate  tag) ---- */
try {
(function() {
      const isSpanish = /\/(es|es-mx)(\/|$)/.test(window.location.pathname);

      const translations = {
        en: {
          // Hero
          hero_eyebrow: "Complete Detox System",
          hero_headline: '7 Days to a <span class="highlight">Cleaner</span>, Healthier <span class="teal">You</span>.',
          hero_sub: "The 7D Challenge is a powerful 2-phase detox system that cleanses your colon and purifies your liver — a complete reset in just 7 days.",
          hero_imageAlt: "7D Challenge Kit - Liver-D, Colon-D, and ProEnzi+ by iEvolution",
          hero_phases: [
            { name: "Phase 1: Colon Cleanse", benefit: "Days 1–5 · Colon-D + ProEnzi+" },
            { name: "Phase 2: Liver Detox", benefit: "Days 6–7 · Liver-D (Support + Mix)" }
          ],
          hero_badge1: "3 Products · 1 Complete System",
          hero_badge2: "100% Natural Ingredients",
          hero_stat1: "7 Days",
          hero_stat1_label: "Full Program",
          hero_stat2: "2 Phases",
          hero_stat2_label: "Detox System",

          // Benefits
          benefits_headline: 'Transform your body from the inside out with the <span class="highlight">7D Challenge</span>.',
          benefits_imageAlt: "7D Challenge Kit - Complete Detox System by iEvolution",
          benefits: [
            "Complete Colon Detoxification",
            "Deep Liver Purification",
            "Improved Digestive Function",
            "Metabolism Acceleration",
            "Immune System Boost",
            "Reduced Bloating & Inflammation"
          ],

          // What's Included
          included_headline: "What's Inside the <span class=\"highlight\">7D Challenge Kit</span>",
          included_subheadline: "A complete 2-phase detox system with everything you need for 7 days",
          included_imageAlt: "7D Challenge Kit Contents - All products included",
          included_items: [
            { number: "2", label: "Liver-D Products", sublabel: "Support + Mix" },
            { number: "1", label: "Colon-D Bag", sublabel: "Detox Tea" },
            { number: "1", label: "ProEnzi+ Bottle", sublabel: "15 Capsules" }
          ],
          included_badgeText: "7-Day Complete System",
          included_note: "Follow the 2-phase protocol: 5 days colon cleanse with Colon-D tea + ProEnzi+, then 2 days liver detox with Liver-D for a complete body reset.",

          // Reviews
          reviews_title: 'Real People. <span>Real Results.</span>',
          reviews_subtitle: "See what our customers are saying about the 7D Challenge",
          reviews_verifiedBuyer: "Verified Buyer",
          reviews: [
            {
              quote: '"I was skeptical at first, but by day 7 I already felt lighter and more energized. The liver detox phase was intense but so worth it. Best investment in my health!"',
              author: "— Andrea M.",
              location: "Dallas, TX"
            },
            {
              quote: '"I\'ve tried many detox programs before but nothing compares to the 7D Challenge. The step-by-step instructions made it so easy to follow. I feel lighter and more energized than ever!"',
              author: "— Roberto G.",
              location: "Phoenix, AZ"
            },
            {
              quote: '"My digestion has completely transformed. No more bloating, no more heartburn. I recommend this kit to everyone in my family. We\'re all doing the challenge together!"',
              author: "— Diana L.",
              location: "Chicago, IL"
            }
          ],
          reviews_stats: [
            "4.8 Average Rating",
            "50,000+ Kits Sold",
            "100% Natural Formula"
          ],

          // Comparison
          comparison_badge: "No Other Detox Compares",
          comparison_title: "Why the 7D Challenge is Your Best Choice",
          comparison_subtitle: "Not all detox programs are created equal. Here's how the 7D Challenge compares to typical cleanses and detox teas.",
          comparison_tableTitle: "Comparing the 7D Challenge<br>To The Competition",
          comparison_productName: "7D Challenge",
          comparison_competitorName: "Other Detox<br>Programs",
          comparison_features: [
            "Complete 2-Phase System (Colon + Liver)",
            "Includes Probiotics & Digestive Enzymes (ProEnzi+)",
            "Deep Liver Purification with Liver-D",
            "Natural Colon Cleanse Tea (Colon-D)",
            "Step-by-Step 7-Day Protocol",
            "All-Natural Ingredients — No Harsh Chemicals",
            "Available in USA & Mexico"
          ],

          // Research
          researchTitle: "A complete system backed by nature",
          researchText1: "The 7D Challenge combines Colon-D's natural herbal tea (persimmon leaves, malva, holy thistle, marshmallow, blessed thistle) with ProEnzi+'s powerful blend of probiotics and digestive enzymes (Lactobacillus acidophilus, bromelain, papain) to cleanse and restore your digestive system from day one.",
          researchText2: "Phase 2 targets your liver with Liver-D's dual-action formula: Liver Support (extra virgin olive oil, Vitamin E) and Liver Mix (ascorbic acid, magnesium sulfate, yucca root, artichoke extract, milk thistle, ginger root, and turmeric with 95% curcuminoids).",
          researchImageAlt: "Natural detox ingredients - herbs, mushrooms, and botanicals",
          statsTitle: 'Your liver processes <span>over 500 vital functions</span> every day',
          statsText1: "Your liver filters blood, produces bile, metabolizes nutrients, and neutralizes toxins around the clock. When it's overloaded with processed foods, alcohol, medications, and environmental toxins, its efficiency drops — leading to fatigue, bloating, skin problems, and weakened immunity.",
          statsText2: "The 7D Challenge works in two phases: first clearing your colon to improve nutrient absorption, then deeply purifying your liver to restore its natural function. This systematic approach delivers a powerful reset in just one week.",
          statsImageAlt: "Liver health and detox benefits infographic",

          // Protocol
          protocol_eyebrow: "Step-by-Step Protocol",
          protocol_title: "Your 7-Day <span>Transformation</span> Plan",
          protocol_sub: "Follow these two phases for a complete body reset",
          protocol_phases: [
            {
              phase: "Phase 1",
              title: "Colon Cleanse",
              days: "Days 1–5 (Monday to Friday)",
              color: "teal",
              steps: [
                "<strong>Sunday night (prep):</strong> Boil 1 liter of water. Once boiled, remove from heat and add the entire contents of the Colon-D bag. Let it steep overnight.",
                "<strong>Monday morning:</strong> Add the tea to a pitcher with 3 liters of room-temperature water (4 liters total).",
                "<strong>Days 1–5, three times daily:</strong> Drink 1 cup (250ml/8oz) of tea + 1 ProEnzi+ capsule before each meal (breakfast, lunch, dinner).",
                "<strong>Important:</strong> Do not heat the tea in a microwave. Do not add sugar or sweeteners. Keep the pitcher refrigerated."
              ]
            },
            {
              phase: "Phase 2",
              title: "Liver Detox",
              days: "Days 6–7 (Saturday & Sunday)",
              color: "amber",
              steps: [
                "<strong>Day 6 morning:</strong> Take 1 ProEnzi+ capsule before a light breakfast (scrambled eggs, light fruit).",
                "<strong>Day 6, 3:00 PM:</strong> Mix Liver Support bottle contents in 24 oz of organic apple nectar (or purified water if diabetic). Refrigerate.",
                "<strong>Day 6, 6:00 PM:</strong> Drink 6 oz of the Liver Support mixture. <strong>8:00 PM:</strong> Drink another 6 oz.",
                "<strong>Day 6, 10:00 PM:</strong> Squeeze 4 oz of fresh lemon juice into the Liver Mix bottle. Shake vigorously for 1 minute. Drink immediately. Lie on your right side to sleep.",
                "<strong>Day 7 morning:</strong> Drink 6 oz Liver Support mixture + 1 ProEnzi+ capsule. <strong>10:00 AM:</strong> Final 6 oz serving.",
                "<strong>Day 7:</strong> Skip breakfast. Light lunch and dinner only (chicken broth with vegetables). Take ProEnzi+ before each meal."
              ]
            },
          ],

          // Download
          download_text: "Download Full Instructions (PDF)",
          download_sub: "English & Spanish · Print-Ready",

          // Experts
          experts_eyebrow: "Meet Our Team",
          experts_title: 'World-Class Health & <span>Wellness Experts</span>',
          experts_subtitle: "Dedicated professionals combining science, innovation, and passion to create revolutionary health solutions.",
          experts_readMore: "Read More",
          experts_cards: [
            { title: "Pharmaceutical Chemist Biologist", specialty: "Formulation Specialist", bio: "Graduate of BUAP (2017) with 8+ years specializing in nutraceutical R&D. Creator of 150+ innovative formulas, expert in liposomal technology.", fullBio: "Graduate of BUAP (2017) with 8+ years specializing in nutraceutical R&D. Creator of 150+ innovative formulas for leading companies, expert in liposomal technology and nanotechnology for enhanced bioavailability.", s1l: "Formulas Created", s2l: "Years Experience" },
            { title: "Pharmaceutical Chemist Biologist", specialty: "Quality Control Expert", bio: "BUAP graduate with 12+ years in pharmaceutical and nutraceutical industries. Expert in GMP implementation and NOM-059 certification.", fullBio: "BUAP graduate with 12+ years in pharmaceutical and nutraceutical industries. Expert in GMP implementation and NOM-059 certification processes.", s1l: "Years Experience", s2l: "Certified" },
            { title: "Pharmaceutical Chemist Biologist", specialty: "Health Regulation Specialist", bio: "BUAP graduate recognized for research excellence at international conferences. Selected by CONACYT (2019) for genetic research.", fullBio: "BUAP graduate recognized for research excellence at international conferences. Selected by CONACYT (2019) for genetic research projects.", s1l: "Years Experience", s2l: "Regulator" },
            { title: "Doctor of Naturopathy", specialty: "Natural Medicine Pioneer", bio: "Doctor of Naturopathy with 10+ years in health and wellness. Pioneering force behind iEvolution\'s Liver Detox formulation.", fullBio: "Doctor of Naturopathy with over 10 years of experience in the health and wellness industry. Pioneering force behind iEvolution\'s acclaimed Liver Detox formulation.", s1l: "Years Practice", s2l: "Patients Helped" },
            { title: "Licensed Nutritionist", specialty: "Clinical Nutrition & Metabolic Health", bio: "Licensed in Nutrition with a postgraduate degree in Clinical Nutrition and Ketogenic Diet certification.", fullBio: "Licensed in Nutrition with a postgraduate degree in Clinical Nutrition and certification in Ketogenic Diet. Specialist in metabolic approach.", s1l: "Nutrition", s2l: "Certified" },
            { title: "Clinical Biochemical Nutrition Specialist", specialty: "Metabolic & Hormonal Health", bio: "Clinical Biochemical Nutrition specialist from Tec de Monterrey. Advanced studies from Yale and Anáhuac.", fullBio: "Clinical Biochemical Nutrition specialist graduated from Tec de Monterrey, focused on metabolic syndrome, fertility, hormonal health, and sports.", s1l: "Trained", s2l: "Member" }
          ],

          // FAQ
          faq_badge: "Got Questions?",
          faq_title: "Frequently Asked Questions",
          faq_subtitle: "Everything you need to know about the 7D Challenge",
          faqs: [
            {
              question: "What is the 7D Challenge?",
              answer: '<p>The 7D Challenge is a powerful 7-day detox program that includes three products working together in a 2-phase system:</p><ul><li><strong>Colon-D (1 bag):</strong> Natural herbal tea for colon cleansing</li><li><strong>Liver-D (Liver Support + Liver Mix):</strong> Dual-action liver purification system</li><li><strong>ProEnzi+ (15 capsules):</strong> Probiotics and digestive enzymes</li></ul><p>The program follows a structured protocol: 5 days of colon cleansing, then 2 days of liver detox.</p>'
            },
            {
              question: "How does the 2-phase system work?",
              answer: '<p><strong>Phase 1 (Days 1–5):</strong> Colon-D tea cleanses your colon while ProEnzi+ provides probiotics and enzymes to support digestion and restore intestinal flora. Drink 3 cups of tea daily, each with 1 ProEnzi+ capsule before meals.</p><p><strong>Phase 2 (Days 6–7):</strong> Liver-D performs a deep liver purification. Liver Support prepares the liver with olive oil and Vitamin E, while Liver Mix delivers a potent blend of curcumin, milk thistle, artichoke extract, and magnesium for a thorough cleanse.</p>'
            },
            {
              question: "What are the main ingredients?",
              answer: '<p><strong>Colon-D:</strong> Persimmon leaves, malva leaves, holy thistle, marshmallow leaves, blessed thistle, and fennel.</p><p><strong>Liver Support:</strong> Extra virgin olive oil and Vitamin E.</p><p><strong>Liver Mix:</strong> Vitamin C (ascorbic acid), magnesium sulfate, yucca root, artichoke 4:1 extract, dandelion 4:1 extract, milk thistle extract, ginger root, and turmeric root extract (95% curcuminoids).</p><p><strong>ProEnzi+:</strong> Lactobacillus acidophilus, L. casei, L. plantarum, bromelain, papain, fungal lipase, fungal lactase, alpha galactosidase, and aspergillus fungal protease.</p>'
            },
            {
              question: "Is the 7D Challenge safe?",
              answer: '<p>Yes! All products in the kit are made with 100% natural ingredients. However, we recommend consulting with your doctor before starting if you are pregnant, nursing, taking medication, or have any medical conditions.</p><p>The liver detox phase (Days 6–7) can cause temporary effects like mild nausea or increased bowel movements — this is normal and a sign the detox is working. Stay well hydrated throughout the process.</p><p>This product is not intended for use by children.</p>'
            },
            {
              question: "What results can I expect?",
              answer: '<p>Results vary by individual, but most people report:</p><ul><li>Reduced bloating and inflammation within the first week</li><li>Improved digestion and regular bowel movements</li><li>Increased energy levels and mental clarity</li><li>Clearer skin and improved overall wellness</li><li>Better sleep quality</li></ul><p>For best results, follow the complete 7-day protocol and maintain healthy eating habits after finishing.</p>'
            },
            {
              question: "Can I eat normally during the challenge?",
              answer: '<p>During <strong>Phase 1 (Days 1–5)</strong>, eat normally but try to reduce processed foods and heavy carbohydrates.</p><p>During <strong>Phase 2 (Days 6–7)</strong>, follow the specific meal guidelines: light breakfast on Day 6, chicken broth for lunch, no dinner. Day 7: skip breakfast, light meals only. Avoid carbohydrates (bread, rice, sugar) as much as possible.</p>'
            },
            {
              question: "How often can I do the 7D Challenge?",
              answer: '<p>If this is your first liver cleanse, we recommend repeating it in 2 weeks. After your second cleanse, do one every 4–5 months for maintenance.</p><p>Many customers also pair the 7D Challenge with other iEvolution products like Daily Liver Plus for daily liver maintenance and Royal Coffee Latte for energy.</p>'
            },
            {
              question: "What is the 21D Challenge?",
              answer: '<p>The 21D Challenge is the extended version that includes all of the 7D Challenge (colon cleanse + liver detox) plus an additional 14-day guided nutrition plan. It also includes 4 bags of Colon-D and 60 ProEnzi+ capsules for extended support.</p><p>If you want the complete transformation with guided nutrition for lasting results, the 21D Challenge is the best choice.</p>'
            }
          ]
        },
        es: {
          // Hero
          hero_eyebrow: "Sistema de Desintoxicación Completo",
          hero_headline: '7 Días para un <span class="highlight">Tú</span> Más Limpio y <span class="teal">Saludable</span>.',
          hero_sub: "El Reto 7D es un poderoso sistema de desintoxicación de 2 fases que limpia tu colon y purifica tu hígado — un reinicio completo en solo 7 días.",
          hero_imageAlt: "Kit Reto 7D - Liver-D, Colon-D y ProEnzi+ de iEvolution",
          hero_phases: [
            { name: "Fase 1: Limpieza de Colon", benefit: "Días 1–5 · Colon-D + ProEnzi+" },
            { name: "Fase 2: Desintoxicación Hepática", benefit: "Días 6–7 · Liver-D (Support + Mix)" }
          ],
          hero_badge1: "3 Productos · 1 Sistema Completo",
          hero_badge2: "Ingredientes 100% Naturales",
          hero_stat1: "7 Días",
          hero_stat1_label: "Programa Completo",
          hero_stat2: "2 Fases",
          hero_stat2_label: "Sistema Detox",

          // Benefits
          benefits_headline: 'Transforma tu cuerpo de adentro hacia afuera con el <span class="highlight">Reto 7D</span>.',
          benefits_imageAlt: "Kit Reto 7D - Sistema de Desintoxicación Completo de iEvolution",
          benefits: [
            "Desintoxicación Completa del Colon",
            "Purificación Profunda del Hígado",
            "Función Digestiva Mejorada",
            "Aceleración del Metabolismo",
            "Fortalecimiento del Sistema Inmune",
            "Reducción de Hinchazón e Inflamación"
          ],

          // What's Included
          included_headline: "Qué Incluye el <span class=\"highlight\">Kit Reto 7D</span>",
          included_subheadline: "Un sistema de desintoxicación completo de 2 fases con todo lo que necesitas para 7 días",
          included_imageAlt: "Contenido del Kit Reto 7D - Todos los productos incluidos",
          included_items: [
            { number: "2", label: "Productos Liver-D", sublabel: "Support + Mix" },
            { number: "1", label: "Bolsa Colon-D", sublabel: "Té Detox" },
            { number: "1", label: "Frasco ProEnzi+", sublabel: "15 Cápsulas" }
          ],
          included_badgeText: "Sistema Completo de 7 Días",
          included_note: "Sigue el protocolo de 2 fases: 5 días de limpieza de colon con té Colon-D + ProEnzi+, luego 2 días de desintoxicación hepática con Liver-D para un reinicio corporal completo.",

          // Reviews
          reviews_title: 'Personas Reales. <span>Resultados Reales.</span>',
          reviews_subtitle: "Mira lo que nuestros clientes dicen sobre el Reto 7D",
          reviews_verifiedBuyer: "Comprador Verificado",
          reviews: [
            {
              quote: '"Al principio estaba escéptica, pero para el día 7 ya me sentía más ligera y con más energía. ¡La fase de desintoxicación del hígado fue intensa pero valió totalmente la pena!"',
              author: "— Andrea M.",
              location: "Dallas, TX"
            },
            {
              quote: '"He probado muchos programas de desintoxicación pero nada se compara con el Reto 7D. Las instrucciones paso a paso lo hicieron muy fácil de seguir. ¡Me siento más ligero y con más energía que nunca!"',
              author: "— Roberto G.",
              location: "Phoenix, AZ"
            },
            {
              quote: '"Mi digestión se ha transformado completamente. No más hinchazón, no más acidez. ¡Recomiendo este kit a toda mi familia. Todos estamos haciendo el reto juntos!"',
              author: "— Diana L.",
              location: "Chicago, IL"
            }
          ],
          reviews_stats: [
            "4.8 Calificación Promedio",
            "50,000+ Kits Vendidos",
            "Fórmula 100% Natural"
          ],

          // Comparison
          comparison_badge: "Ningún Otro Detox Se Compara",
          comparison_title: "Por Qué el Reto 7D es Tu Mejor Opción",
          comparison_subtitle: "No todos los programas de desintoxicación son iguales. Así es como el Reto 7D se compara con limpiezas típicas y tés detox.",
          comparison_tableTitle: "Comparando el Reto 7D<br>Con la Competencia",
          comparison_productName: "Reto 7D",
          comparison_competitorName: "Otros Programas<br>Detox",
          comparison_features: [
            "Sistema Completo de 2 Fases (Colon + Hígado)",
            "Incluye Probióticos y Enzimas Digestivas (ProEnzi+)",
            "Purificación Profunda del Hígado con Liver-D",
            "Limpieza Natural del Colon con Té (Colon-D)",
            "Protocolo de 7 Días Paso a Paso",
            "Ingredientes 100% Naturales — Sin Químicos Agresivos",
            "Disponible en USA y México"
          ],

          // Research
          researchTitle: "Un sistema completo respaldado por la naturaleza",
          researchText1: "El Reto 7D combina el té herbal natural de Colon-D (hojas de caqui, malva, cardo santo, malvavisco, cardo bendito) con la poderosa mezcla de probióticos y enzimas digestivas de ProEnzi+ (Lactobacillus acidophilus, bromelina, papaína) para limpiar y restaurar tu sistema digestivo desde el primer día.",
          researchText2: "La Fase 2 se enfoca en tu hígado con la fórmula de doble acción de Liver-D: Liver Support (aceite de oliva extra virgen, Vitamina E) y Liver Mix (ácido ascórbico, sulfato de magnesio, raíz de yuca, extracto de alcachofa, cardo mariano, raíz de jengibre y extracto de cúrcuma con 95% curcuminoides).",
          researchImageAlt: "Ingredientes naturales de desintoxicación - hierbas y botánicos",
          statsTitle: 'Tu hígado procesa <span>más de 500 funciones vitales</span> cada día',
          statsText1: "Tu hígado filtra la sangre, produce bilis, metaboliza nutrientes y neutraliza toxinas sin parar. Cuando está sobrecargado con alimentos procesados, alcohol, medicamentos y toxinas ambientales, su eficiencia disminuye — causando fatiga, hinchazón, problemas de piel e inmunidad debilitada.",
          statsText2: "El Reto 7D trabaja en dos fases: primero limpiando tu colon para mejorar la absorción de nutrientes, luego purificando profundamente tu hígado para restaurar su función natural. Este enfoque sistemático ofrece un reinicio poderoso en solo una semana.",
          statsImageAlt: "Infografía de salud hepática y beneficios de desintoxicación",

          // Protocol
          protocol_eyebrow: "Protocolo Paso a Paso",
          protocol_title: "Tu Plan de <span>Transformación</span> de 7 Días",
          protocol_sub: "Sigue estas dos fases para un reinicio corporal completo",
          protocol_phases: [
            {
              phase: "Fase 1",
              title: "Limpieza de Colon",
              days: "Días 1–5 (Lunes a Viernes)",
              color: "teal",
              steps: [
                "<strong>Domingo por la noche (preparación):</strong> Hierve 1 litro de agua. Una vez que hierva, apaga el fuego y coloca todo el contenido de la bolsa de Colon-D. Deja reposar toda la noche.",
                "<strong>Lunes por la mañana:</strong> Añade el té a una jarra con 3 litros de agua al tiempo (4 litros en total).",
                "<strong>Días 1–5, tres veces al día:</strong> Toma 1 taza (250ml/8oz) de té + 1 cápsula de ProEnzi+ antes de cada comida (desayuno, comida, cena).",
                "<strong>Importante:</strong> No calentar el té en microondas. No agregar azúcar ni endulzante. Mantener la jarra refrigerada."
              ]
            },
            {
              phase: "Fase 2",
              title: "Desintoxicación Hepática",
              days: "Días 6–7 (Sábado y Domingo)",
              color: "amber",
              steps: [
                "<strong>Día 6 mañana:</strong> Toma 1 cápsula de ProEnzi+ antes de un desayuno ligero (huevos revueltos, poca fruta).",
                "<strong>Día 6, 3:00 PM:</strong> Mezcla el contenido de Liver Support en 710ml/24oz de néctar de manzana orgánico (o agua purificada si eres diabético). Refrigera.",
                "<strong>Día 6, 6:00 PM:</strong> Toma 178ml/6oz de la mezcla. <strong>8:00 PM:</strong> Toma otros 178ml/6oz.",
                "<strong>Día 6, 10:00 PM:</strong> Exprime 120ml/4oz de jugo de limón fresco en el frasco de Liver Mix. Agita vigorosamente 1 minuto. Toma inmediatamente. Acuéstate sobre tu lado derecho para dormir.",
                "<strong>Día 7 mañana:</strong> Toma 178ml/6oz de la mezcla + 1 cápsula de ProEnzi+. <strong>10:00 AM:</strong> Última porción de 178ml/6oz.",
                "<strong>Día 7:</strong> No desayunar. Comida y cena ligeras (caldo de pollo con verduras). Toma ProEnzi+ antes de cada comida."
              ]
            },
          ],

          // Download
          download_text: "Descargar Instrucciones Completas (PDF)",
          download_sub: "Inglés y Español · Listo para Imprimir",

          // Experts
          experts_eyebrow: "Conoce a Nuestro Equipo",
          experts_title: 'Expertos de Clase Mundial en Salud y <span>Bienestar</span>',
          experts_subtitle: "Profesionales dedicados que combinan ciencia, innovación y pasión para crear soluciones revolucionarias de salud.",
          experts_readMore: "Leer Más",
          experts_cards: [
            { title: "Químico Farmacéutico Biólogo", specialty: "Especialista en Formulación", bio: "Egresado de la BUAP (2017) con más de 8 años en I+D nutracéutico. Creador de más de 150 fórmulas innovadoras, experto en tecnología liposomal.", fullBio: "Egresado de la BUAP (2017) con más de 8 años en I+D nutracéutico. Creador de más de 150 fórmulas innovadoras, experto en tecnología liposomal y nanotecnología.", s1l: "Fórmulas Creadas", s2l: "Años de Experiencia" },
            { title: "Químico Farmacéutico Biólogo", specialty: "Experto en Control de Calidad", bio: "Egresado de la BUAP con más de 12 años en industrias farmacéuticas y nutracéuticas. Experto en implementación GMP y certificación NOM-059.", fullBio: "Egresado de la BUAP con más de 12 años en industrias farmacéuticas y nutracéuticas. Experto en implementación GMP y procesos de certificación NOM-059.", s1l: "Años de Experiencia", s2l: "Certificado" },
            { title: "Químico Farmacéutico Biólogo", specialty: "Especialista en Regulación Sanitaria", bio: "Egresada de la BUAP reconocida por excelencia en investigación en conferencias internacionales. Seleccionada por CONACYT (2019).", fullBio: "Egresada de la BUAP reconocida por excelencia en investigación en conferencias internacionales. Seleccionada por CONACYT (2019) para investigación genética.", s1l: "Años de Experiencia", s2l: "Reguladora" },
            { title: "Doctor en Naturopatía", specialty: "Pionero en Medicina Natural", bio: "Doctor en Naturopatía con más de 10 años en salud y bienestar. Fuerza pionera detrás de la formulación Liver Detox de iEvolution.", fullBio: "Doctor en Naturopatía con más de 10 años en la industria de salud y bienestar. Fuerza pionera detrás de la formulación Liver Detox de iEvolution.", s1l: "Años de Práctica", s2l: "Pacientes Ayudados" },
            { title: "Nutrióloga Licenciada", specialty: "Nutrición Clínica y Salud Metabólica", bio: "Licenciada en Nutrición con posgrado en Nutrición Clínica y certificación en Dieta Cetogénica.", fullBio: "Licenciada en Nutrición con posgrado en Nutrición Clínica y certificación en Dieta Cetogénica. Especialista en enfoque metabólico.", s1l: "Nutrición", s2l: "Certificada" },
            { title: "Especialista en Nutrición Bioquímica Clínica", specialty: "Salud Metabólica y Hormonal", bio: "Especialista en Nutrición Bioquímica Clínica del Tec de Monterrey. Estudios avanzados en Yale y Anáhuac.", fullBio: "Especialista en Nutrición Bioquímica Clínica del Tec de Monterrey, enfocado en síndrome metabólico, fertilidad, salud hormonal y deportes.", s1l: "Formado", s2l: "Miembro" }
          ],

          // FAQ
          faq_badge: "¿Tienes Preguntas?",
          faq_title: "Preguntas Frecuentes",
          faq_subtitle: "Todo lo que necesitas saber sobre el Reto 7D",
          faqs: [
            {
              question: "¿Qué es el Reto 7D?",
              answer: '<p>El Reto 7D es un poderoso programa de desintoxicación de 7 días que incluye tres productos trabajando juntos en un sistema de 2 fases:</p><ul><li><strong>Colon-D (1 bolsa):</strong> Té herbal natural para limpieza del colon</li><li><strong>Liver-D (Liver Support + Liver Mix):</strong> Sistema de purificación hepática de doble acción</li><li><strong>ProEnzi+ (15 cápsulas):</strong> Probióticos y enzimas digestivas</li></ul><p>El programa sigue un protocolo estructurado: 5 días de limpieza de colon, luego 2 días de desintoxicación hepática.</p>'
            },
            {
              question: "¿Cómo funciona el sistema de 2 fases?",
              answer: '<p><strong>Fase 1 (Días 1–5):</strong> El té Colon-D limpia tu colon mientras ProEnzi+ proporciona probióticos y enzimas para apoyar la digestión y restaurar la flora intestinal. Bebe 3 tazas de té al día, cada una con 1 cápsula de ProEnzi+ antes de las comidas.</p><p><strong>Fase 2 (Días 6–7):</strong> Liver-D realiza una purificación profunda del hígado. Liver Support prepara el hígado con aceite de oliva y Vitamina E, mientras Liver Mix entrega una mezcla potente de curcumina, cardo mariano, extracto de alcachofa y magnesio.</p>'
            },
            {
              question: "¿Cuáles son los ingredientes principales?",
              answer: '<p><strong>Colon-D:</strong> Hojas de caqui, hojas de malva, cardo santo, hojas de malvavisco, cardo bendito e hinojo.</p><p><strong>Liver Support:</strong> Aceite de oliva extra virgen y Vitamina E.</p><p><strong>Liver Mix:</strong> Vitamina C (ácido ascórbico), sulfato de magnesio, raíz de yuca, extracto de alcachofa 4:1, extracto de diente de león 4:1, extracto de cardo mariano, raíz de jengibre y extracto de raíz de cúrcuma (95% curcuminoides).</p><p><strong>ProEnzi+:</strong> Lactobacillus acidophilus, L. casei, L. plantarum, bromelina, papaína, lipasa fúngica, lactasa fúngica, alfa galactosidasa y proteasa fúngica de aspergillus.</p>'
            },
            {
              question: "¿Es seguro el Reto 7D?",
              answer: '<p>¡Sí! Todos los productos del kit están hechos con ingredientes 100% naturales. Sin embargo, recomendamos consultar con tu médico antes de comenzar si estás embarazada, amamantando, tomando medicamentos o tienes alguna condición médica.</p><p>La fase de desintoxicación hepática (Días 6–7) puede causar efectos temporales como náuseas leves o aumento en las evacuaciones — esto es normal y una señal de que la desintoxicación está funcionando. Mantente bien hidratado durante todo el proceso.</p><p>Este producto no está indicado para ser utilizado por niños.</p>'
            },
            {
              question: "¿Qué resultados puedo esperar?",
              answer: '<p>Los resultados varían por individuo, pero la mayoría de las personas reportan:</p><ul><li>Reducción de hinchazón e inflamación en la primera semana</li><li>Digestión mejorada y evacuaciones regulares</li><li>Aumento de niveles de energía y claridad mental</li><li>Piel más clara y bienestar general mejorado</li><li>Mejor calidad de sueño</li></ul><p>Para mejores resultados, sigue el protocolo completo de 7 días y mantén hábitos alimenticios saludables después de terminar.</p>'
            },
            {
              question: "¿Puedo comer normalmente durante el reto?",
              answer: '<p>Durante la <strong>Fase 1 (Días 1–5)</strong>, come normalmente pero trata de reducir alimentos procesados y carbohidratos pesados.</p><p>Durante la <strong>Fase 2 (Días 6–7)</strong>, sigue las indicaciones específicas de comida: desayuno ligero el Día 6, caldo de pollo para la comida, no cenar. Día 7: no desayunar, comidas ligeras solamente. Evita carbohidratos (pan, arroz, azúcar) lo más posible.</p>'
            },
            {
              question: "¿Cada cuánto puedo hacer el Reto 7D?",
              answer: '<p>Si es tu primera limpieza hepática, recomendamos repetirla en 2 semanas. Después de la segunda limpieza, haz una cada 4–5 meses como mantenimiento.</p><p>Muchos clientes también combinan el Reto 7D con otros productos iEvolution como Daily Liver Plus para mantenimiento hepático diario y Royal Coffee Latte para energía.</p>'
            },
            {
              question: "¿Qué es el Reto 21D?",
              answer: '<p>El Reto 21D es la versión extendida que incluye todo lo del Reto 7D (limpieza de colon + desintoxicación hepática) más un plan nutricional guiado de 14 días adicionales. También incluye 4 bolsas de Colon-D y 60 cápsulas de ProEnzi+ para un apoyo extendido.</p><p>Si quieres la transformación completa con nutrición guiada para resultados duraderos, el Reto 21D es la mejor opción.</p>'
            }
          ]
        }
      };


      /* ===== PARCHE "3 REGALOS GRATIS": textos nuevos/cambiados EN + ES ===== */
      (function (en, es) {
        // Hero
        en.hero_eyebrow = "Complete Detox System + 3 Free Gifts";
        es.hero_eyebrow = "Sistema Detox Completo + 3 Regalos Gratis";
        en.hero_headline = '7 Days to a <span class="highlight">Cleaner</span>, Healthier <span class="teal">You</span>. And 30 more to keep it.';
        es.hero_headline = '7 Días para un <span class="highlight">Tú</span> Más Limpio y <span class="teal">Saludable</span>. Y 30 más para mantenerlo.';
        en.hero_sub = "The 7D Challenge cleanses your colon and purifies your liver in one week. Then three full-size products, included free, take over so the reset lasts long after day 7.";
        es.hero_sub = "El Reto 7D limpia tu colon y purifica tu hígado en una semana. Después, tres productos completos, incluidos gratis, toman el relevo para que el reinicio dure mucho más allá del día 7.";
        en.hero_phases.push({ name: "Phase 3: Keep It — FREE", benefit: "Days 8–37 · Daily Liver Plus + 365 + SMR" });
        es.hero_phases.push({ name: "Fase 3: Mantenlo — GRATIS", benefit: "Días 8–37 · Daily Liver Plus + 365 + SMR" });
        en.hero_badge1 = "Kit + 3 Full-Size Gifts · 1 Box";
        es.hero_badge1 = "Kit + 3 Regalos Completos · 1 Caja";
        en.hero_stat2 = "3 Gifts";            en.hero_stat2_label = '<span data-r7g="gifts">$169.97</span> Value · Free';
        es.hero_stat2 = "3 Regalos";          es.hero_stat2_label = '<span data-r7g="gifts">$169.97</span> de valor · Gratis';

        // Por qué los regalamos (sección nueva)
        en.why_eyebrow = "Why we're giving them away";
        es.why_eyebrow = "Por qué los regalamos";
        en.why_title = 'The challenge ends on day 7. <span>Your results shouldn\'t.</span>';
        es.why_title = 'El reto termina el día 7. <span>Tus resultados no deberían.</span>';
        en.why_intro = "For years we watched the same thing happen: people finish the 7D Challenge feeling lighter and more energized, and two weeks later they're back where they started. The ones who kept their results were the ones who came back for three specific products. So we stopped waiting for them to come back. Every kit now ships with all three, and we don't charge for them.";
        es.why_intro = "Durante años vimos lo mismo: la gente termina el Reto 7D sintiéndose más ligera y con más energía, y dos semanas después está donde empezó. Los que mantenían sus resultados eran los que volvían por tres productos específicos. Así que dejamos de esperar a que volvieran. Ahora cada kit sale con los tres, y no los cobramos.";
        en.why_free = "FREE"; es.why_free = "GRATIS";
        en.why_cards = [
          { when: "Day 8 onward", title: "Your liver, kept clean", text: "Phase 2 flushes the liver. Daily Liver Plus (milk thistle, turmeric, beet root, vitamin D3) keeps it working at that level for the next 30 days. Two capsules with a meal, that's it.", meta: '60 capsules · 30-day supply · <span data-r7g="gift-liver">$49.99</span> value' },
          { when: "Day 8 onward", title: "Refuel what the cleanse cleared", text: "A freshly cleaned colon absorbs nutrients better than it has in years. That's the window to feed it: 100+ vitamins, minerals, probiotics, enzymes and superfoods in one morning scoop.", meta: '30 scoops · family size · <span data-r7g="gift-365">$49.99</span> value' },
          { when: "Day 8 onward", title: "The light meal, solved", text: "After the cleanse, the hard part is not sliding back into heavy meals. SMR makes eating light effortless: 22 g of protein, 229 calories, ready in 30 seconds, any time as a meal or a snack. After the challenge, it's an easy 229-calorie meal for the days you want to eat light.", meta: '21 servings · vanilla · <span data-r7g="gift-smr">$69.99</span> value' }
        ];
        es.why_cards = [
          { when: "A partir del día 8", title: "Tu hígado, limpio y así se queda", text: "La fase 2 limpia el hígado a fondo. Daily Liver Plus (cardo mariano, cúrcuma, betabel, vitamina D3) lo mantiene trabajando a ese nivel los siguientes 30 días. Dos cápsulas con una comida, nada más.", meta: '60 cápsulas · 30 días · <span data-r7g="gift-liver">$49.99</span> de valor' },
          { when: "A partir del día 8", title: "Recarga lo que la limpieza dejó listo", text: "Un colon recién limpio absorbe nutrientes mejor que en años. Ese es el momento de alimentarlo: más de 100 vitaminas, minerales, probióticos, enzimas y superalimentos en un scoop cada mañana.", meta: '30 scoops · tamaño familiar · <span data-r7g="gift-365">$49.99</span> de valor' },
          { when: "A partir del día 8", title: "La comida ligera, resuelta", text: "Después de la limpieza, lo difícil es no volver a las comidas pesadas. SMR hace que comer ligero sea fácil: 22 g de proteína, 229 calorías, listo en 30 segundos, a cualquier hora como comida o snack. Después del reto, es una comida fácil de 229 calorías para los días en que quieres comer ligero.", meta: '21 porciones · vainilla · <span data-r7g="gift-smr">$69.99</span> de valor' }
        ];
        en.why_timeline = [{ d: "Days 1–5", p: "Colon-D + ProEnzi+" }, { d: "Days 6–7", p: "Liver-D" }, { d: "Days 8–37", p: "Daily Liver Plus + 365 + SMR" }];
        es.why_timeline = [{ d: "Días 1–5", p: "Colon-D + ProEnzi+" }, { d: "Días 6–7", p: "Liver-D" }, { d: "Días 8–37", p: "Daily Liver Plus + 365 + SMR" }];
        en.why_closing = 'Three full-size products. <strong data-r7g="gifts">$169.97</strong> if you bought them separately. <strong>$0</strong> with your kit.';
        es.why_closing = 'Tres productos completos. <strong data-r7g="gifts">$169.97</strong> si los compraras por separado. <strong>$0</strong> con tu kit.';

        // Qué incluye
        en.included_headline = "What's Inside <span class=\"highlight\">Your Box</span>";
        es.included_headline = "Qué Incluye <span class=\"highlight\">Tu Caja</span>";
        en.included_subheadline = "The complete 2-phase detox system for 7 days, plus 30 days of follow-up. All in one box.";
        es.included_subheadline = "El sistema detox completo de 2 fases para 7 días, más 30 días de seguimiento. Todo en una sola caja.";
        en.included_items.push({ number: "1", label: "Daily Liver Plus", sublabel: "60 Capsules · FREE" }, { number: "1", label: "365 Family Size", sublabel: "30 Scoops · FREE" }, { number: "1", label: "SMR Vanilla", sublabel: "21 Servings · FREE" });
        es.included_items.push({ number: "1", label: "Daily Liver Plus", sublabel: "60 Cápsulas · GRATIS" }, { number: "1", label: "365 Tamaño Familiar", sublabel: "30 Scoops · GRATIS" }, { number: "1", label: "SMR Vainilla", sublabel: "21 Porciones · GRATIS" });
        en.included_giftsLabel = "+ Your 3 free gifts";
        en.included_imageAlt = "7D Challenge Kit + Daily Liver Plus, 365 and SMR";
        en.included_imageSrc = "https://cdn.shopify.com/s/files/1/0570/3909/3811/files/reto7d-gratis-02-value-stack_900x900.png";
        es.included_imageSrc = "https://cdn.shopify.com/s/files/1/0570/3909/3811/files/reto7d-gratis-es-02-recibo-valor_900x900.png";
        es.included_imageSrcMX = "https://cdn.shopify.com/s/files/1/0570/3909/3811/files/reto7d-gratis-mx-02-recibo-valor_900x900.png";
        es.included_imageAlt = "Kit Reto 7D + Daily Liver Plus, 365 y SMR";
        es.included_giftsLabel = "+ Tus 3 regalos gratis";
        en.included_badgeText = "7-Day System + 30-Day Follow-Up";
        es.included_badgeText = "Sistema de 7 Días + 30 Días de Seguimiento";
        en.included_note = "Days 1–5: Colon-D tea + ProEnzi+. Days 6–7: Liver-D. From day 8: 1 scoop of 365 every morning, 2 Daily Liver Plus capsules with a meal, and SMR whenever you want a light meal.";
        es.included_note = "Días 1–5: té Colon-D + ProEnzi+. Días 6–7: Liver-D. Desde el día 8: 1 scoop de 365 cada mañana, 2 cápsulas de Daily Liver Plus con una comida, y SMR cuando quieras una comida ligera.";

        // Comparativa (2 filas después de "Step-by-Step 7-Day Protocol", índice 4)
        en.comparison_features.splice(5, 0, '3 Full-Size Products Included Free (<span data-r7g="gifts">$169.97</span> Value)', "30-Day Follow-Up Plan After the Cleanse");
        es.comparison_features.splice(5, 0, '3 Productos Completos Incluidos Gratis (<span data-r7g="gifts">$169.97</span> de valor)', "Plan de Seguimiento de 30 Días Después de la Limpieza");

        // Protocolo: fase 3
        en.protocol_sub = "Two phases to reset your body, and a third, included free, to keep it that way";
        es.protocol_sub = "Dos fases para reiniciar tu cuerpo, y una tercera, incluida gratis, para mantenerlo así";
        en.protocol_phases.push({ phase: "Phase 3", title: "Keep It — Free", days: "Days 8–37 (the month after)", color: "coral", steps: [
          "<strong>Every morning:</strong> 1 scoop (11 g) of 365 in 8 oz of cold water, before lunch.",
          "<strong>With a meal:</strong> 2 Daily Liver Plus capsules with water. Same time every day works best.",
          "<strong>When you need a light meal:</strong> 2 scoops (40 g) of SMR in 10–12 oz (300–350 ml) of cold water, shake well. Works as breakfast, dinner or a snack.",
          "<strong>Week 2:</strong> If this was your first liver cleanse, repeat the 7D Challenge in 2 weeks. Keep taking Daily Liver Plus and 365 in between."
        ] });
        es.protocol_phases.push({ phase: "Fase 3", title: "Mantenlo — Gratis", days: "Días 8–37 (el mes siguiente)", color: "coral", steps: [
          "<strong>Cada mañana:</strong> 1 scoop (11 g) de 365 en 8 oz (240 ml) de agua fría, antes de la comida.",
          "<strong>Con una comida:</strong> 2 cápsulas de Daily Liver Plus con agua. Funciona mejor a la misma hora todos los días.",
          "<strong>Cuando necesites una comida ligera:</strong> 2 scoops (40 g) de SMR en 300–350 ml de agua fría, agita bien. Sirve como desayuno, cena o snack.",
          "<strong>Semana 2:</strong> Si fue tu primera limpieza hepática, repite el Reto 7D en 2 semanas. Sigue tomando Daily Liver Plus y 365 mientras tanto."
        ] });

        // FAQ: cambia la 7 (cada cuánto) y agrega 2 antes de la del 21D
        en.faqs[6].answer = '<p>If this is your first liver cleanse, we recommend repeating it in 2 weeks. After your second cleanse, do one every 4–5 months for maintenance.</p><p>Between challenges, keep taking Daily Liver Plus and 365 (both included free in your kit) so your liver and your nutrition stay where the cleanse left them.</p>';
        es.faqs[6].answer = '<p>Si es tu primera limpieza hepática, recomendamos repetirla en 2 semanas. Después de tu segunda limpieza, haz una cada 4–5 meses como mantenimiento.</p><p>Entre retos, sigue tomando Daily Liver Plus y 365 (ambos incluidos gratis en tu kit) para que tu hígado y tu nutrición se queden donde la limpieza los dejó.</p>';
        en.faqs.splice(7, 0,
          { question: "Why are the 3 products free? What's the catch?", answer: '<p>There\'s no catch. The 7D Challenge costs the same as it always has. We added Daily Liver Plus, 365 and SMR because they\'re what our customers buy after the challenge, and the people who use them are the ones who keep their results. Shipping them in the same box costs us less than a second order, and it\'s better for you.</p><p>They\'re the same full-size products we sell separately: 60 capsules, 30 scoops and 21 servings.</p>' },
          { question: "What do I do after day 7?", answer: '<p>Days 8 to 37 are Phase 3, and everything you need is already in the box: 1 scoop of 365 every morning, 2 Daily Liver Plus capsules with a meal, and SMR whenever you need a light meal.</p><p>If this was your first liver cleanse, repeat the 7D Challenge two weeks later.</p>' });
        es.faqs.splice(7, 0,
          { question: "¿Por qué los 3 productos son gratis? ¿Cuál es el truco?", answer: '<p>No hay truco. El Reto 7D cuesta lo mismo de siempre. Agregamos Daily Liver Plus, 365 y SMR porque son lo que nuestros clientes compran después del reto, y quienes los usan son los que mantienen sus resultados. Enviarlos en la misma caja nos cuesta menos que un segundo pedido, y para ti es mejor.</p><p>Son los mismos productos completos que vendemos por separado: 60 cápsulas, 30 scoops y 21 porciones.</p>' },
          { question: "¿Qué hago después del día 7?", answer: '<p>Los días 8 a 37 son la Fase 3, y todo lo que necesitas ya viene en la caja: 1 scoop de 365 cada mañana, 2 cápsulas de Daily Liver Plus con una comida, y SMR cuando necesites una comida ligera.</p><p>Si fue tu primera limpieza hepática, repite el Reto 7D dos semanas después.</p>' });
      })(translations.en, translations.es);
      /* ===== fin del parche ===== */

      function renderDescription() {
        const lang = isSpanish ? 'es' : 'en';
        const t = translations[lang];
        if (isSpanish) document.documentElement.lang = 'es';

        // === Hero ===
        const heroEyebrow = document.querySelector('#ie-21d-hero .hero-eyebrow');
        if (heroEyebrow) heroEyebrow.textContent = t.hero_eyebrow;
        const heroHeadline = document.querySelector('#ie-21d-hero .hero-headline');
        if (heroHeadline) heroHeadline.innerHTML = t.hero_headline;
        const heroSub = document.querySelector('#ie-21d-hero .hero-sub');
        if (heroSub) heroSub.textContent = t.hero_sub;
        const heroImg = document.querySelector('#ie-21d-hero .hero-image > img');
        if (heroImg) heroImg.alt = t.hero_imageAlt;
        document.querySelectorAll('#ie-21d-hero .phase-pill').forEach((pill, i) => {
          if (t.hero_phases[i]) {
            const name = pill.querySelector('.pill-name');
            const benefit = pill.querySelector('.pill-benefit');
            if (name) name.textContent = t.hero_phases[i].name;
            if (benefit) benefit.textContent = t.hero_phases[i].benefit;
          }
        });
        const heroBadges = document.querySelectorAll('#ie-21d-hero .hero-badge');
        if (heroBadges[0]) { const svg0 = heroBadges[0].querySelector('svg'); heroBadges[0].innerHTML = ''; if (svg0) heroBadges[0].appendChild(svg0); heroBadges[0].appendChild(document.createTextNode(' ' + t.hero_badge1)); }
        if (heroBadges[1]) { const svg1 = heroBadges[1].querySelector('svg'); heroBadges[1].innerHTML = ''; if (svg1) heroBadges[1].appendChild(svg1); heroBadges[1].appendChild(document.createTextNode(' ' + t.hero_badge2)); }
        document.querySelectorAll('#ie-21d-hero .floating-stat').forEach((stat, i) => {
          const sn = stat.querySelector('.stat-number');
          const sl = stat.querySelector('.stat-label');
          if (i === 0) { if (sn) sn.textContent = t.hero_stat1; if (sl) sl.textContent = t.hero_stat1_label; }
          if (i === 1) { if (sn) sn.textContent = t.hero_stat2; if (sl) sl.innerHTML = t.hero_stat2_label; }
        });

        // === Benefits ===
        const bH = document.querySelector('#ie-21d-benefits .benefits-headline');
        if (bH) bH.innerHTML = t.benefits_headline;
        const bI = document.querySelector('#ie-21d-benefits .benefits-image img');
        if (bI) bI.alt = t.benefits_imageAlt;
        document.querySelectorAll('#ie-21d-benefits .benefit-text').forEach((el, i) => { if (t.benefits[i]) el.textContent = t.benefits[i]; });

        // === Included ===
        const iH = document.querySelector('#ie-21d-included .included-headline');
        if (iH) iH.innerHTML = t.included_headline;
        const iS = document.querySelector('#ie-21d-included .included-subheadline');
        if (iS) iS.textContent = t.included_subheadline;
        const iImg = document.querySelector('#ie-21d-included .included-image img');
        if (iImg) iImg.alt = t.included_imageAlt;
        if (iImg && t.included_imageSrc) { var isMX = /\/es-mx(\/|$)/.test(window.location.pathname) || !!(window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'MXN'); iImg.src = (isMX && t.included_imageSrcMX) || t.included_imageSrc; }
        document.querySelectorAll('#ie-21d-included .item-number').forEach((el, i) => { if (t.included_items[i]) el.textContent = t.included_items[i].number; });
        document.querySelectorAll('#ie-21d-included .item-label').forEach((el, i) => { if (t.included_items[i]) el.textContent = t.included_items[i].label; });
        document.querySelectorAll('#ie-21d-included .item-sublabel').forEach((el, i) => { if (t.included_items[i]) el.textContent = t.included_items[i].sublabel; });
        const badge = document.querySelector('#ie-21d-included .supply-badge span');
        if (badge) badge.textContent = t.included_badgeText;
        const note = document.querySelector('#ie-21d-included .dosage-note p');
        if (note) note.textContent = t.included_note;

        // === Reviews ===
        const rT = document.querySelector('#ie-21d-reviews .reviews-title');
        const rS = document.querySelector('#ie-21d-reviews .reviews-subtitle');
        if (rT) rT.innerHTML = t.reviews_title;
        if (rS) rS.textContent = t.reviews_subtitle;
        document.querySelectorAll('#ie-21d-reviews .review-card').forEach((card, i) => {
          if (t.reviews[i]) {
            const q = card.querySelector('.review-quote'); const a = card.querySelector('.review-author');
            const l = card.querySelector('.review-location'); const v = card.querySelector('.review-verified');
            if (q) q.textContent = t.reviews[i].quote; if (a) a.textContent = t.reviews[i].author; if (l) l.textContent = t.reviews[i].location;
            if (v) { const svg = v.querySelector('svg'); v.innerHTML = ''; if (svg) v.appendChild(svg); v.appendChild(document.createTextNode(' ' + t.reviews_verifiedBuyer)); }
          }
        });
        document.querySelectorAll('#ie-21d-reviews .stat-text').forEach((s, i) => { if (t.reviews_stats[i]) s.textContent = t.reviews_stats[i]; });

        // === Comparison ===
        const cB = document.querySelector('#ie-21d-comparison .comparison-badge');
        const cT = document.querySelector('#ie-21d-comparison .comparison-title');
        const cS = document.querySelector('#ie-21d-comparison .comparison-subtitle');
        if (cB) cB.childNodes[0].textContent = t.comparison_badge;
        if (cT) cT.textContent = t.comparison_title;
        if (cS) cS.textContent = t.comparison_subtitle;
        const tT = document.querySelector('#ie-21d-comparison .table-header-title');
        const pN = document.querySelector('#ie-21d-comparison .header-product-name');
        const cN = document.querySelector('#ie-21d-comparison .header-competitor-name');
        if (tT) tT.innerHTML = t.comparison_tableTitle;
        if (pN) pN.textContent = t.comparison_productName;
        if (cN) cN.innerHTML = t.comparison_competitorName;
        document.querySelectorAll('#ie-21d-comparison .row-feature').forEach((f, i) => { if (t.comparison_features[i]) f.innerHTML = t.comparison_features[i]; });

        // === Research ===
        const resT = document.querySelector('#ie-21d-research .research-title');
        const resTx = document.querySelectorAll('#ie-21d-research .research-text');
        if (resT) resT.textContent = t.researchTitle;
        if (resTx[0]) resTx[0].textContent = t.researchText1;
        if (resTx[1]) resTx[1].textContent = t.researchText2;
        const stT = document.querySelector('#ie-21d-research .stats-title');
        const stTx = document.querySelectorAll('#ie-21d-research .stats-text');
        if (stT) stT.innerHTML = t.statsTitle;
        if (stTx[0]) stTx[0].textContent = t.statsText1;
        if (stTx[1]) stTx[1].textContent = t.statsText2;

        // === Protocol ===
        const prE = document.querySelector('#ie-21d-protocol .protocol-eyebrow');
        const prT = document.querySelector('#ie-21d-protocol .protocol-title');
        const prS = document.querySelector('#ie-21d-protocol .protocol-sub');
        if (prE) prE.textContent = t.protocol_eyebrow;
        if (prT) prT.innerHTML = t.protocol_title;
        if (prS) prS.textContent = t.protocol_sub;
        document.querySelectorAll('#ie-21d-protocol .protocol-phase').forEach((ph, i) => {
          if (t.protocol_phases[i]) {
            const pLabel = ph.querySelector('.phase-label'); const pTitle = ph.querySelector('.phase-title');
            const pDays = ph.querySelector('.phase-days');
            if (pLabel) pLabel.textContent = t.protocol_phases[i].phase;
            if (pTitle) pTitle.textContent = t.protocol_phases[i].title;
            if (pDays) pDays.textContent = t.protocol_phases[i].days;
            ph.querySelectorAll('.step-text').forEach((step, j) => {
              if (t.protocol_phases[i].steps[j]) step.innerHTML = t.protocol_phases[i].steps[j];
            });
          }
        });

        // === Download Button ===
        const dlText = document.querySelector('#ie-21d-protocol .download-text');
        const dlSub = document.querySelector('#ie-21d-protocol .download-sub');
        if (dlText) dlText.textContent = t.download_text;
        if (dlSub) dlSub.textContent = t.download_sub;

        // === Experts ===
        const expEyebrow = document.querySelector('.iev-experts-wrapper .iev-section-eyebrow');
        const expH2 = document.querySelector('.iev-experts-wrapper .iev-section-header h2');
        const expP = document.querySelector('.iev-experts-wrapper .iev-section-header p');
        if (expEyebrow) expEyebrow.textContent = t.experts_eyebrow;
        if (expH2) expH2.innerHTML = t.experts_title;
        if (expP) expP.textContent = t.experts_subtitle;
        document.querySelectorAll('.iev-experts-wrapper .iev-read-more').forEach(function(btn) { btn.textContent = t.experts_readMore; });
        document.querySelectorAll('.iev-experts-wrapper .iev-expert-card').forEach(function(card, i) {
          if (t.experts_cards && t.experts_cards[i]) {
            var ex = t.experts_cards[i];
            var eT = card.querySelector('.iev-expert-title');
            var eS = card.querySelector('.iev-expert-specialty');
            var eB = card.querySelector('.iev-expert-bio');
            var sL = card.querySelectorAll('.iev-stat-label');
            if (eT) eT.textContent = ex.title;
            if (eS) eS.textContent = ex.specialty;
            if (eB) eB.textContent = ex.bio;
            if (sL[0]) sL[0].textContent = ex.s1l;
            if (sL[1]) sL[1].textContent = ex.s2l;
            card.dataset.title = ex.title;
            card.dataset.specialty = ex.specialty;
            card.dataset.bio = ex.fullBio;
            card.dataset.stat1Label = ex.s1l;
            card.dataset.stat2Label = ex.s2l;
          }
        });

        // === FAQ ===
        const fB = document.querySelector('#ie-21d-faq .faq-badge');
        const fT = document.querySelector('#ie-21d-faq .faq-title');
        const fS = document.querySelector('#ie-21d-faq .faq-subtitle');
        if (fB) fB.textContent = t.faq_badge;
        if (fT) fT.textContent = t.faq_title;
        if (fS) fS.textContent = t.faq_subtitle;
        document.querySelectorAll('#ie-21d-faq .faq-item').forEach((item, i) => {
          if (t.faqs[i]) {
            const qT = item.querySelector('.faq-question-text');
            const aC = item.querySelector('.faq-answer-content');
            if (qT) qT.textContent = t.faqs[i].question;
            if (aC) aC.innerHTML = t.faqs[i].answer;
          }
        });

        // === Why 3 free gifts (sección nueva) ===
        const wE = document.querySelector('#ie-21d-why .why-eyebrow');
        const wT = document.querySelector('#ie-21d-why .why-title');
        const wI = document.querySelector('#ie-21d-why .why-intro');
        if (wE) wE.textContent = t.why_eyebrow;
        if (wT) wT.innerHTML = t.why_title;
        if (wI) wI.textContent = t.why_intro;
        document.querySelectorAll('#ie-21d-why .why-card').forEach((card, i) => {
          const c = t.why_cards && t.why_cards[i]; if (!c) return;
          const w = card.querySelector('.why-when'), h = card.querySelector('.why-card-title'), p = card.querySelector('.why-card-text'), m = card.querySelector('.why-meta'), f = card.querySelector('.why-free');
          if (w) w.textContent = c.when; if (h) h.textContent = c.title; if (p) p.textContent = c.text; if (m) m.innerHTML = c.meta; if (f) f.textContent = t.why_free;
        });
        document.querySelectorAll('#ie-21d-why .why-chip').forEach((chip, i) => {
          const c = t.why_timeline && t.why_timeline[i]; if (!c) return;
          const d = chip.querySelector('strong'), p = chip.querySelector('span');
          if (d) d.textContent = c.d; if (p) p.textContent = c.p;
        });
        const wC = document.querySelector('#ie-21d-why .why-closing');
        if (wC) wC.innerHTML = t.why_closing;
        const gL = document.querySelector('#ie-21d-included .included-gifts-label span');
        if (gL) gL.textContent = t.included_giftsLabel;
        // precios vivos: si el widget ya cargó, vuelve a rellenar los hooks recién renderizados
        if (window.__r7g) document.dispatchEvent(new CustomEvent('r7g:ready', { detail: window.__r7g }));
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderDescription); else renderDescription();
    })();
} catch (e) { if (window.console) console.error('[reto7d] block 3 failed:', e); }
} /* __r7gLoaded */
